import { connect } from 'react-redux';

function mapStateToProps(state) {
	return {
		isRouted: state.routing && state.routing.isRouted,
	};
}

export default connect(mapStateToProps);